
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Activity, Server, Zap, Globe } from 'lucide-react';
import { Card } from '../ui/Card';

export const ClusterStats: React.FC = () => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Card className="bg-stone-900 text-white border-stone-800">
                <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-nobel-gold/20 rounded-lg text-nobel-gold"><Activity size={18}/></div>
                    <span className="text-xs font-bold uppercase tracking-widest text-stone-400">Network TPS</span>
                </div>
                <div className="text-2xl font-mono font-bold">4,238</div>
                <div className="text-[10px] text-green-400 mt-1 flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span> Optimal
                </div>
            </Card>

            <Card className="bg-white border-stone-200">
                 <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-stone-100 rounded-lg text-stone-600"><Server size={18}/></div>
                    <span className="text-xs font-bold uppercase tracking-widest text-stone-500">Active Nodes</span>
                </div>
                <div className="text-2xl font-mono font-bold text-stone-900">1,892</div>
                <div className="text-[10px] text-stone-400 mt-1">Global Distribution</div>
            </Card>

            <Card className="bg-white border-stone-200">
                 <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-stone-100 rounded-lg text-stone-600"><Zap size={18}/></div>
                    <span className="text-xs font-bold uppercase tracking-widest text-stone-500">Block Time</span>
                </div>
                <div className="text-2xl font-mono font-bold text-stone-900">400ms</div>
                <div className="text-[10px] text-stone-400 mt-1">Finality &lt; 1s</div>
            </Card>

             <Card className="bg-white border-stone-200">
                 <div className="flex items-center gap-3 mb-2">
                    <div className="p-2 bg-stone-100 rounded-lg text-stone-600"><Globe size={18}/></div>
                    <span className="text-xs font-bold uppercase tracking-widest text-stone-500">Epoch</span>
                </div>
                <div className="text-2xl font-mono font-bold text-stone-900">432</div>
                <div className="text-[10px] text-stone-400 mt-1">Next in 12h 30m</div>
            </Card>
        </div>
    );
};
